import { render, staticRenderFns } from "./TabContentWrapper.vue?vue&type=template&id=3c1b0ce6&"
import script from "./TabContentWrapper.vue?vue&type=script&lang=js&"
export * from "./TabContentWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports